const urls = {
  landing: '/assets/landing/home/banner.jpg',
  guides: '/assets/landing/guides/banner.jpg',
  education: '/assets/landing/education/banner.jpg',
  engineApi: '/assets/landing/engine/banner.jpg',
  cloudApi: '/assets/landing/cloud/banner.jpg',
  legacyApi: '/assets/landing/cloud/banner.jpg',
};

export default urls;
